import React from 'react';
import Styled from 'styled';
import ReactMarkdown from 'react-markdown';

import defaultStyles from './markdown.scss';

interface Props {
    styles: typeof defaultStyles;
}

const Markdown: React.FC<Props> = props => {
    const { styles, children } = props;

    let backwardCompatibleChildren = children;
    if (typeof children === 'string') {
        backwardCompatibleChildren = (backwardCompatibleChildren as string).replace(
            new RegExp(/^_(.*)_$/, 'mg'),
            '# $1'
        );
        backwardCompatibleChildren = (backwardCompatibleChildren as string).replace(
            new RegExp(/^\+(.*)\+$/, 'mg'),
            '> $1'
        );
    }

    return (
        <ReactMarkdown linkTarget='_blank' className={styles.markdown}>
            {backwardCompatibleChildren}
        </ReactMarkdown>
    );
};

export default Styled(defaultStyles)(Markdown);

